import React from 'react'
import type { FC } from 'react'
import { useEffect, useState } from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'

import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
} from 'draft-js'
import { Editor } from 'react-draft-wysiwyg'
import draftToHtml from 'draftjs-to-html'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'

import type { ITheme } from '@homeviews/styles'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {
      color: theme.colors.grey650,
    },
  }),
)

interface IProps {
  className?: string
  onChange: any
  fieldName: string
  value?: string
  placeholder?: string
}

const RichTextEditor: FC<IProps> = ({
  fieldName,
  value,
  onChange,
  placeholder,
}) => {
  const classes = useStyles()

  const [editorState, setEditorState] = useState(EditorState.createEmpty())
  const [initialValueSet, setInitialValueSet] = useState(false)

  useEffect(() => {
    if (initialValueSet) {
      return
    }
    if (value) {
      try {
        const blocksFromHtml = convertFromHTML(value)
        const { contentBlocks, entityMap } = blocksFromHtml
        const contentState = ContentState.createFromBlockArray(
          contentBlocks,
          entityMap,
        )
        const editorState = EditorState.createWithContent(contentState)
        setEditorState(editorState)
      } catch {
        //
      }
      setInitialValueSet(true)
    }
  }, [value, initialValueSet])

  const onEditorStateChange = (newValue) => {
    const newHtmlValue = draftToHtml(
      convertToRaw(editorState.getCurrentContent()),
    )
    if (newHtmlValue !== value) {
      onChange(fieldName)(newHtmlValue)
    }
    setEditorState(newValue)
  }
  return (
    <div className={classes.root}>
      <Editor
        editorState={editorState}
        wrapperClassName="c-richTextEditorWrapper"
        editorClassName="c-richTextEditor"
        onEditorStateChange={onEditorStateChange}
        placeholder={placeholder || 'Add text'}
        toolbar={{
          options: ['inline', 'list', 'textAlign', 'link'],
          inline: {
            inDropdown: false,
            options: ['bold', 'italic', 'underline'],
          },
          list: { inDropdown: false, options: ['unordered', 'ordered'] },
          textAlign: { inDropdown: false },
          link: { inDropdown: false, options: ['link'] },
        }}
      />
    </div>
  )
}

export default RichTextEditor
